import Alpine from "alpinejs";
import EmblaCarousel, { type EmblaCarouselType, type EmblaOptionsType } from "embla-carousel";

export const interviewSlider = () => {
  Alpine.data("interviewSlider", () => ({
    emblaApi: null as EmblaCarouselType | null,
    dots: [] as number[],
    selectedIndex: 0,
    slideCount: 0,
    showControls: false,
    onSelect: null as (() => void) | null,
    desktopMediaQuery: null as MediaQueryList | null,
    resizeHandler: null as (() => void) | null,
    init() {
      const viewport = this.$refs.viewport as HTMLElement | null;
      if (!viewport) return;

      this.slideCount = viewport.querySelectorAll("li").length;
      if (this.slideCount <= 0) return;

      this.desktopMediaQuery = window.matchMedia("(min-width: 768px)");
      const updateControls = () => {
        const isDesktop = this.desktopMediaQuery?.matches ?? false;
        this.showControls = this.slideCount > 1
          && (this.slideCount > 2 || !isDesktop)
          && !(this.slideCount === 3 && isDesktop);
      };

      if (this.slideCount === 1) {
        updateControls();
        return;
      }

      const options: EmblaOptionsType = {
        loop: this.slideCount > 2,
        align: "center",
        slidesToScroll: 1,
        containScroll: this.slideCount === 2 ? false : "trimSnaps",
        breakpoints: {
          "(min-width: 768px)": {
            align: this.slideCount > 2 ? "start" : "center",
            active: this.slideCount > 2,
          },
        },
      };

      this.emblaApi = EmblaCarousel(viewport, options);
      this.dots = this.emblaApi.scrollSnapList().map((_, index) => index);

      this.onSelect = () => {
        if (!this.emblaApi) return;
        this.selectedIndex = this.emblaApi.selectedScrollSnap();
      };
      this.emblaApi.on("select", this.onSelect);
      this.emblaApi.on("reInit", this.onSelect);
      updateControls();
      this.resizeHandler = () => updateControls();
      this.desktopMediaQuery.addEventListener("change", this.resizeHandler);
      this.onSelect();
    },
    prev() {
      this.emblaApi?.scrollPrev();
    },
    next() {
      this.emblaApi?.scrollNext();
    },
    goTo(index: number) {
      this.emblaApi?.scrollTo(index);
    },
    destroy() {
      if (this.emblaApi && this.onSelect) {
        this.emblaApi.off("select", this.onSelect);
        this.emblaApi.off("reInit", this.onSelect);
      }
      if (this.desktopMediaQuery && this.resizeHandler) {
        this.desktopMediaQuery.removeEventListener("change", this.resizeHandler);
      }
      this.emblaApi?.destroy();
      this.emblaApi = null;
      this.onSelect = null;
      this.desktopMediaQuery = null;
      this.resizeHandler = null;
    },
  }));
};
